/**
 * Note Detail Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.noteDetailFormatter = function(value, row) {
    if (!row.description) {
        return '<span class="text-muted">' + __('No description') + '</span>';
    }
    let div = document.createElement('div');
    div.textContent = row.description;
    return div.innerHTML.replace(/\n/g, '<br>');
};
